// ======================================================================
// File Name       : usageStatus
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/ActionTypes';

export function getCurrentUsageStatus(responseData) {
  return {
    type: ActionTypes.GET_CURRENT_USAGE_STATUS,
    responseData,
  };
}
